import { onElementExistRunOnce } from 'cropwise_accounts/helpers/dom_utils';

export const initIdpChangePopupResult = () => {
  onElementExistRunOnce('[data-idp-popup-result]', () => {
    const el = document.querySelector('[data-idp-popup-result]');

    if (window.opener) {
      const isSuccess = el.dataset.idpPopupResult === 'success';
      const type = isSuccess ? 'idp_change_success' : 'idp_change_failure';
      // The opener is a cross-origin MFE, so a concrete targetOrigin would make
      // the browser drop the message. '*' is safe here: the payload is only a
      // success/failure flag and the listener validates event.origin and
      // event.source.
      window.opener.postMessage({ type }, '*'); // NOSONAR: see comment above
    }

    const closeBtn = document.querySelector('[data-idp-close-button]');
    closeBtn?.addEventListener('click', () => window.close());
  });
};
